import Promise from "bluebird";
import EntryDescription from "module/edesc/EntryDescription";
import {createAction} from 'util/redux'
import {EntryDesc} from 'generated/JavaTOmodifications'

export const getDependencyPromise = () => Promise.resolve(EntryDescription.fetchOnce());

const NAMESPACE = 'ENTRY_DESC/'
export const toggleEntryDescFavAction = createAction<{ entryDescId: number, forceAdd?: boolean }>(NAMESPACE + 'toggleFav')
export const setEntryDescFavIDsAction = createAction<number[]>(NAMESPACE + 'setFavIDs')
export const setEntryDescFavEditModeAction = createAction<{ status: boolean, reset?: boolean }>(NAMESPACE + 'setFavEditMode')
export const resetEntryDescModelsAction = createAction<EntryDesc[]>(NAMESPACE + 'reset')
